import { Phone, Search, Settings } from 'lucide-react';
import { useFadeUp } from '@/hooks/useFadeUp';

const steps = [
  {
    number: '01',
    icon: Phone,
    title: 'Appelez ou demandez un devis',
    description: 'Contactez-nous par téléphone au 0800 20 410 ou via notre formulaire en ligne. Décrivez-nous votre problème, nous vous conseillons immédiatement.',
  },
  {
    number: '02',
    icon: Search,
    title: 'Diagnostic sur place',
    description: 'Nous nous déplaçons à votre domicile pour un diagnostic complet et gratuit. Nous identifions la panne et vous proposons la meilleure solution.',
  },
  {
    number: '03',
    icon: Settings,
    title: 'Réparation et garantie',
    description: 'Une fois le devis accepté, nous intervenons rapidement pour réparer votre volet. Travail soigné, pièces de qualité, garantie 10 ans.',
  },
];

export function HowItWorks() {
  const ref = useFadeUp();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div ref={ref} className="fade-up max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="section-title">Comment ça marche ?</h2>
          <p className="section-subtitle">
            Un processus simple et efficace pour la réparation de votre volet roulant
          </p>
        </div>

        <div className="relative">
          {/* Connecting line (desktop) */}
          <div className="hidden md:block absolute top-14 left-[16%] right-[16%] h-0.5 bg-background-300" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
            {steps.map((step, i) => {
              const Icon = step.icon;
              return (
                <div key={i} className="relative flex flex-col items-center text-center">
                  {/* Number circle */}
                  <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent-500 text-white flex items-center justify-center font-heading font-bold text-xl md:text-2xl mb-5">
                    {step.number}
                  </div>
                  {/* Icon */}
                  <div className="w-10 h-10 rounded-lg bg-accent-50 flex items-center justify-center mb-3">
                    <Icon className="w-5 h-5 text-accent-500" />
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-700 text-sm md:text-base mb-2">
                    {step.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed max-w-xs">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}